var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"customCheckbox",attrs:{"value":_vm.value,"label":_vm.label,"color":"#16293F","hide-details":""},on:{"change":function($event){return _vm.$emit('input',$event)},"input":function($event){return _vm.$emit('input',$event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }